import { css, SerializedStyles } from '@emotion/react';
import { theme } from 'global';
import {
  fieldErrorRow,
  fieldHelperText,
  shimmer,
} from '../ActivationStep.styles';

export * from '../ActivationStep.styles';

export const overlay = css`
  position: absolute;
  inset: 56px 0 0;
  background: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  height: 100vh;
  z-index: 10;
`;

export const verificationIllustration = css`
  position: relative;
  width: 96px;
  height: 96px;
`;

export const successSkeleton = (height: number): SerializedStyles => css`
  width: 100%;
  height: ${height}px;
  background: ${theme.colors.neutral[50]};
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    width: 40%;
    background: linear-gradient(
      90deg,
      rgba(230, 230, 230, 0.01) 0%,
      #e6e6e6 50%,
      rgba(230, 230, 230, 0.01) 100%
    );
    animation: ${shimmer} 1.4s ease-in-out infinite;
  }
`;

export const textfield = css`
  width: 100%;
  margin: 0 !important;

  /* suppress MUI's built-in error end-adornment icon inside the input */
  .MuiInputAdornment-root {
    display: none;
  }

  .MuiFormHelperText-root {
    ${fieldHelperText};
  }

  .errorRow {
    ${fieldErrorRow};
  }
`;

export const errorTextField = css`
  ${fieldHelperText};
`;

export const addEmailBtn = css`
  && {
    align-self: flex-start;
    padding: 8px 0;
    color: ${theme.colors.primary.medium};
    font-weight: ${theme.fontWeights.medium};
  }
`;
